import EventEmitter from "base/EventEmitter";
import $ from "jquery";

export default class WebsiteModal extends EventEmitter {

    constructor() {
        super();
        this.isShown = false;
        this.$modal = null;
    }

    buildElement() {
        throw new Error("Modal must override buildElement()");
    }

    bindEvents() {
        throw new Error("Modal must override bindEvents()");
    }

    build() {
        if ($(".js-modals-container").length === 0) {
            $("body").append(eotwJSXFactory('div', {class: "js-modals-container modal-container"}));
        }
        if (!this.$modal) {
            this.buildElement();
            this.bindEvents();
            this.bindModalEvents();
        }
    }

    bindModalEvents() {
        this.$modal.on("click", ".js-close-modal", () => {
            this.close();
            return false;
        });
    }

    show() {

        if (this.isShown) return;
        this.isShown = true;
        this.build();
        this.emit("show", this.$modal);

        $(".js-modals-container").append(this.$modal);

        setTimeout(() => {
            $("body").addClass("modal-active");
            this.$modal.addClass("modal--active");
        });

        WebsiteModal.open_modals.push(this);
    }

    close() {
        if (!this.isShown) return;
        if (this.$modal) {
            this.$modal.removeClass("modal--active");
        }
        WebsiteModal.open_modals = WebsiteModal.open_modals.filter((other) => other !== this);
        this.emit("close");

        this.isShown = false;

        setTimeout(() => {
            if (this.$modal) {
                this.$modal.remove();
            }
            this.emit("closeDone");
            this.destroy();

            if (WebsiteModal.open_modals.length === 0) {
                $("body").removeClass("modal-active");
            }
        }, 400);
    }

    destroy() {
        super.destroy();
        if (this.$modal) {
            // Remove all listeners etc
            this.$modal.remove();
        }

        this.$modal = null;
    }

    static close_all() {
        WebsiteModal.open_modals.forEach((modal) => modal.close());
    }

    static bind_events() {
        let $body = $("body");
        $body.on("click", ".modal--active .modal__main", (e) => {
            e.stopPropagation();
        }).on("click", () => ($body.is(".modal-active") && WebsiteModal.close_all()) || true);
    }
}

WebsiteModal.open_modals = [];
WebsiteModal.bind_events();
